import { render, staticRenderFns } from "./cohortBingding.vue?vue&type=template&id=6f7f6ddc&scoped=true"
import script from "./cohortBingding.vue?vue&type=script&lang=js"
export * from "./cohortBingding.vue?vue&type=script&lang=js"
import style0 from "./cohortBingding.vue?vue&type=style&index=0&id=6f7f6ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7f6ddc",
  null
  
)

export default component.exports